var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('h1',[_vm._v("todos")]),_c('todo-input',{on:{"enter":_vm.onAddTodo},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }